"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldSet = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _identifier = require("../../util/identifier");
var _FormField = require("../FormField/FormField.context");
var _FieldSet = require("./FieldSet.styles");
var _excluded = ["children", "description", "disabled", "error", "legend", "optional", "required", "size"];
/**
 * @extends FormField
 * @related [`LabeledControl`]
 * @subcomponents ['Legend']
 * @since 8.0.0
 */
var FieldSet = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    description = _ref.description,
    disabled = _ref.disabled,
    error = _ref.error,
    legend = _ref.legend,
    optional = _ref.optional,
    required = _ref.required,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Generate an id to link FormHelp to the FieldSet
  var descriptionId = (0, _react.useRef)((0, _identifier.identifier)()).current;

  // Context for nested Legend and FormField components
  var context = {
    optional: optional,
    required: required,
    disabled: disabled
  };
  if (description) {
    context.descriptionId = descriptionId;
  }
  if (typeof size !== 'undefined') {
    context.size = size;
  }
  if (typeof error !== 'undefined') {
    context.error = error;
  }
  return /*#__PURE__*/_react.default.createElement(_FieldSet.StyledFieldSet, (0, _extends2.default)({
    ref: forwardedRef,
    "aria-describedby": context.descriptionId
  }, rest), /*#__PURE__*/_react.default.createElement(_FormField.FormFieldContext.Provider, {
    value: context
  }, legend, children, description));
});
exports.FieldSet = FieldSet;
FieldSet.displayName = 'FieldSet';
FieldSet.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A group of thematically related controls, usually `LabeledControl`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * A node that describes the field set, typically a
   * `FormHelp`. This will automatically associate the
   * `FormHelp` with the field set using
   * [`aria-describedby`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute).
   */
  description: _propTypes.default.node,
  /**
   * Displays the field set in a disabled state. Inherited by the nested form controls.
   */
  disabled: _propTypes.default.bool,
  /**
   * A `Legend` used to caption the group of controls.
   */
  legend: _propTypes.default.node.isRequired,
  /**
   * Indicates the field set is required. Inherited by the nested form controls and legend.
   */
  required: _propTypes.default.bool,
  /**
   * Indicates the field set is optional in the legend.
   */
  optional: _propTypes.default.bool,
  /**
   * Sets the `size` for all nested form controls.
   */
  size: _propTypes.default.oneOf(['md', 'lg']),
  /**
   * Displays the field set in an error state. Inherited by the nested form controls and
   * FormHelp text.
   */
  error: _propTypes.default.bool
} : {};